
// import TransitionExpand from "../animation/transition-expand";
export default {
  // components: { TransitionExpand },
  data() {
    return {
      items: null,
      allItems: null,
      mobileView: false,
      activeFilter: null,
      categories: [`${this.$t("general")}`], // First is hardcoded, others are added by admin!
      activeItem: null,
      options: [
        {
          name: "category",
          label: "Kategorija (VELIKIM SLOVIMA)",
          type: "text",
        },
        {
          name: "subtitle",
          label: "Pitanje",
          type: "textarea",
        },
        {
          name: "description",
          label: "Odgovor",
          type: "tipTap",
        },
      ],
    };
  },
  computed: {
    returnCat() {
      return [...new Map(this.categories.map((item) => [item, item])).values()];
    },
  },
  watch: {
    $isInEditMode(v) {
      if (!v) {
        this.filterCategory(this.$t("general"));
      }
    },
  },
  mounted() {
    this.filterCategory(this.$t("general"));
    this.$nextTick(function () {
      if (window.removeEventListener) {
        window.addEventListener("resize", this.isMobile);
      }
      this.isMobile();
    });
  },
  methods: {
    isMobile() {
      if (process.browser) {
        if (window && window.innerWidth <= 580) {
          this.mobileView = true;
        } else {
          this.mobileView = false;
        }
      }
    },
    setItems(value) {
      this.items = value;
      this.allItems = value;
      const cat = value.map((e) => e.category);
      this.categories.push(...cat);
    },
    filterCategory(value) {
      if (!this.items || this.$isInEditMode) return;
      this.activeFilter = value;
      this.items = this.allItems.filter((e) => e.category === value);
    },
  },
};
